import { render, staticRenderFns } from "./PainelIframe.vue?vue&type=template&id=4a2b50ad"
import script from "./PainelIframe.vue?vue&type=script&lang=js"
export * from "./PainelIframe.vue?vue&type=script&lang=js"
import style0 from "./PainelIframe.vue?vue&type=style&index=0&id=4a2b50ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports